import { Flex, Grid, Image, List, Paper, Text } from "@mantine/core";
import { RiVipCrownFill } from "react-icons/ri";
import "./LeaderboardCard.css";
import NusLogo from "../../../images/NusLogo.png";
import FgvLogo from "../../../images/FgvLogo.png";
import MsuLogo from "../../../images/MsuLogo.jpg";

export default function LeaderboardCard({user, rank, currUser}) { 
    // console.log({"user": user, "rank": rank, "currUser": currUser })
    return <List.Item py="md" p="xl" className={currUser ? "gradient-border" : "border-top-gray"} icon={
        <Text weight="bold" className={(rank <= 3 ? (rank === 1 ? "gold" : rank === 2 ? "silver" : "bronze") : "")} >{rank}</Text>
        }>
        <Grid align="center">
            <Grid.Col span="content" align="center" justify="center">               
                <Paper pos="relative" shadow="sm" radius={9999} withBorder>
                    <Image className={rank <= 3 ? "rank " + (rank === 1 ? "gold" : rank === 2 ? "silver" : "bronze") : ""} 
                        alt="user image" src={user.university === "National University of Singapore" 
                            ? NusLogo 
                            : (user.university === "FGV" 
                                ? FgvLogo
                                : MsuLogo)} width={48} height={48} fit="cover" radius={9999} /> {/*Placeholder image*/}
                    {rank === 1 ? <RiVipCrownFill className="crown" /> : null}
                </Paper> 
            </Grid.Col>

            <Grid.Col span="auto">
                <Text weight="bold" size="sm"
                    color={user.university === "National University of Singapore" 
                            ? "var(--color-nuswap-brand-1)" 
                            : (user.university === "FGV" 
                                ? "var(--color-nuswap-secondary-2)" 
                                : "blue")}>{user.university}</Text>
                { currUser ? <Text weight="bolder">You</Text> : <Text weight="bolder">{user.alias}</Text>}
                <Flex align="center" wrap="nowrap" justify="flex-start" columnGap={3}>
                    <Text size="xs" align="left" inline>Cumulative P/L:</Text>
                    <Text size="xs" inline>{user.total_return}</Text>
                    <Text size="xs" inline>|</Text>
                    <Text size="xs" align="left" inline>Attended:</Text>
                    <Text size="xs" inline>{user.attended}</Text>
                </Flex>
            </Grid.Col>
        </Grid>
    </List.Item>
}
